import $ from 'jquery';
import _ from 'underscore';
import Model from 'cdna/core/model';
import FaqEntryCollection from './faqEntryCollection.js';

export default Model.extend({
    defaults: {
        Title: 'FAQ',
        Entries: [],        
        isActive: false,
        canPrint: true
    },
    modelTypes: {
        Entries: FaqEntryCollection
    },   
    initialize() {
        const scriptId = this.get('ScriptId');
        if (scriptId) this.addEntriesFromScriptId(scriptId);

        this.on('change:ScriptId', (model, scriptId) => {
            if (scriptId) this.addEntriesFromScriptId(scriptId);
        });
    },
    addEntriesFromScriptId(scriptId) {
        const content = $('script#'+ scriptId).text();
        const faqElements = $('<div>')
            .append(content)
            .children()
            .filter('div[title]');

        const entries = _.map(faqElements, (el) => {
            let $el = $(el);
            return {
                Title: $el.attr('title'),
                Html: $el.html()
            };
        });

        this.get('Entries').add(entries);
    },
    addEntriesFrompath(path) {
        $.get(path).done(function(markup) {

        });
    }
});



/** WEBPACK FOOTER **
 ** ./client/faq/faqPageModel.js
 **/